const quoteHeaderSection = docData => {
  docData.doc.setFontSize(10)

  docData.doc.text(
    ['8, 663 Newcastle Street, Leederville WA 6007', '+61 8 9328 1788', 'www.thesandbox.com.au'],
    20,
    docData.yAxis,
    {
      align: 'left',
    }
  )

  const text = docData.doc.text(
    ['187 Carr, Place, Leederville WA 6007', '+61 8 9227 6901', 'www.soundbyte.net.au'],
    docData.doc.internal.pageSize.getWidth() - 161,
    docData.yAxis,
    {
      align: 'left',
    }
  )

  docData.yAxis += 3 * docData.doc.getFontSize() * 1.15 + docData.buffer

  return docData
}

export default quoteHeaderSection
